import { useGremlinQuery } from 'hooks/use-gremlin-query'

import type { AxiosRequestConfig } from 'axios'
import type { TeamInfo } from 'types/api/orgs/team'

export const QUERY_KEY_ORG_BASE = 'ORGS'

export const orgsQueryKeys = {
  oneById: (identifier: string) => [QUERY_KEY_ORG_BASE, identifier]
}

export function useGetTeamInfo(
  identifier: string,
  axiosRequestOptions: AxiosRequestConfig = {}
) {
  const requestStatus = useGremlinQuery<TeamInfo[]>(
    `/orgs/${identifier}`,
    axiosRequestOptions,
    {
      initialData: [],
      queryKey: orgsQueryKeys.oneById(identifier)
    }
  )

  return requestStatus
}
